import { render, staticRenderFns } from "./ParsedCustomParagraph.vue?vue&type=template&id=cba0d862"
import script from "./ParsedCustomParagraph.vue?vue&type=script&lang=js"
export * from "./ParsedCustomParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports